import React, { Component, PropTypes } from 'react';
import ContentBlock from '../block/content';
import ConfirmDialog from  '../../form/confirm';
import Label from '../../form/label';

export class ProfileRequest extends Component {

	constructor(props) {
		super();

		this.state = {};
	}

	render() {
		let { formValues, item, index } = this.props;
		let user = item.user;

		if (!user) {
			return null;
		}

		return (
			<ContentBlock title=''>
				{(index === 0) && (
					<Label label={'Accounts requesting to join ' + formValues.name} className='account-edit-profile__request__label'></Label>
				)}
				<ConfirmDialog ref='confirm' />
				<div className='account-edit-profile__request'>
					<div className='account-edit-profile__request__item span6 span6-tablet span100p-mobile'>
						{user.name} ( {user.email} )
					</div>

					{(item.stateAsText === 'waiting') && (
						<div className='span100p account-edit-profile__request__actions'>
							<a className='button button--dark' onClick={() => { this.props.approve(); }}>Approve</a>
							{' '}
							<a className='button button--light' onClick={() => { this.props.reject(); }}>Reject</a>
						</div>
					)}
				</div>
			</ContentBlock>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/profileEdit/profileRequest.js
 **/